import { useTranslation } from "react-i18next";
import { Moon, Sun } from "lucide-react";
import { Icon } from "@/components/ui/icon";
import { useSheetMode } from "@/hooks/use-sheet-mode";
import { SHEET_MODES } from "@/lib/sheet-mode";
import { cn } from "@/lib/utils";

/*
  Day or night, beside the locale and cut the same way (lang-toggle.tsx): two
  pressed-state buttons in one named group, so the state is programmatic and
  survives greyscale. Each glyph names itself for a screen reader.
*/

const GLYPH = { day: Sun, night: Moon } as const;

export function SheetModeToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [mode, pick] = useSheetMode();
  return (
    <div
      role="group"
      aria-label={t("nav.mode.label")}
      className={cn(
        "inline-flex shrink-0 items-center gap-0.5 rounded-full border border-hairline p-0.5",
        className
      )}
    >
      {SHEET_MODES.map((m) => (
        <button
          key={m}
          type="button"
          onClick={() => pick(m)}
          aria-pressed={mode === m}
          aria-label={t(`nav.mode.${m}`)}
          title={t(`nav.mode.${m}`)}
          className={cn(
            "inline-flex h-10 min-w-11 items-center justify-center rounded-full px-2 transition-colors",
            mode === m ? "bg-surface-strong text-text-1" : "text-text-3 hover:text-text-2"
          )}
        >
          <Icon glyph={GLYPH[m]} scale="inline" />
        </button>
      ))}
    </div>
  );
}
